import React from 'react'
import { timestampFormat } from 'libs/date-format'
import { NoData } from 'components/NoData'
import { Grid } from 'semantic-ui-react'

/**
 *
 * @param {object} props
 * @param {array} props.invoices
 */
export function InvoiceHistory({ invoices }) {
  if (invoices.length === 0) {
    return (
      <Wrapper>
        <NoData className="ui segment" fill={false} />
      </Wrapper>
    )
  }

  return (
    <Wrapper>
      <table className="ui basic small table">
        <thead>
          <tr>
            <th>ID</th>
            <th>Date</th>
            <th colSpan={2}>Amount</th>
          </tr>
        </thead>

        <tbody>
          {invoices.map((invoice) => (
            <tr key={invoice.id}>
              <td>{invoice.number}</td>
              <td>{timestampFormat(invoice.created)}</td>
              <td>
                <PaidStatus isPaid={invoice.paid} />
                {formatPrice(invoice.amount_due)}
              </td>
              <td className="right aligned">
                <a href={invoice.invoice_pdf} target="_blank" rel="noopener">
                  View invoice
                </a>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </Wrapper>
  )
}

function formatPrice(price) {
  if (Number.parseFloat(price) % 1 === 0) {
    return Number.parseFloat(price).toLocaleString('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 0,
    })
  } else {
    return Number.parseFloat(price).toLocaleString('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 1,
    })
  }
}

function Wrapper({ children }) {
  return (
    <Grid>
      <Grid.Column width={12}>{children}</Grid.Column>
    </Grid>
  )
}

function PaidStatus({ isPaid = true }) {
  if (isPaid) {
    return <i className="icon green fas fa-check" />
  }

  return <i className="icon fas fa-xmark red" />
}



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/components/InvoiceHistory/index.js